import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './BasicCard.css';
import gif1 from "../../assets/gif/landing/capital efficiency.gif"
import { useEffect } from 'react';
import { useState } from 'react';

export default function BasicCard({ content, image }) {
  return (
    <Card className='card'>
      <CardContent className='card-content-container'>
        <p className='card-content'>
          {
           content 
          }
        </p> 
        <div className='gif-background'>
          <img src={image} alt={content}/>
        </div>
      </CardContent>
    </Card>
  );
}
